exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-size {\n  color: #888;\n  font-size: 18px;\n  line-height: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/map-size/map-size.component.scss
// module id = ../../../../../src/app/components/map-size/map-size.component.scss
// module chunks = main